module.exports = __webpack_public_path__ + "media/images/emblems/Saas_Balen_Wappen-c6f05a4573d362c520a8e3ac0a3a4067.png";